module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nLoNbZ/images/9781439657157.jpg?1684514926442",
      "alt": "This image is the cover for the book Boston Light, Images of America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Boston Light, Images of America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("On September 14, 1716, Boston Light became the first lighthouse established in Colonial America. With many ships floundering in the treacherous waters of the Massachusetts harbor, there was a great need for navigational aid. At night and during storms, it was difficult to discern the entrance to the main shipping channel of Nantasket Roads, situated between the Brewster islands and the town of Hull. The ledges had become a graveyard for ships, resulting in great loss to human life and cargo--a deterrent to European colonization efforts. Ship captains and merchants petitioned the colonial government for a lighthouse to be erected on Little Brewster Island as a way of safe passage to the inner harbor. Three hundred years later, Boston Light continues to serve its purpose. Today, the lighthouse is protected by an ever-present Coast Guard civilian keeper and a cadre of specially trained Coast Guard Auxiliary volunteer assistant keepers.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sally R. Snowman, James G. Thomson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Prior to her appointment as the civilian keeper in 2003, Sally R. Snowman, PhD, was a learning disabilities specialist. James G. Thomson, an avid sailor, worked for the Engineering Division in the town of Plymouth, Massachusetts. He and Sally met as volunteers in the US Coast Guard Auxiliary and married at Boston Light in 1994.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0